import defaultValues from "@/constant/defaultValues";
import { publicRoutePaths } from "@/routes/public.routes.config";
import { buildPath } from "@/utils/common";
import { lowerCase } from "lodash";
import { Link } from "react-router-dom";
import companylogo from "@/images/Company-logo.svg";

const MpSupplierCard = ({ data, handleQuoteClick, showContact = false }) => {
  const { IMAGE_PATH } = defaultValues;

  return (
    <div className='mp-supplier market-place-card'>
      <div className='inner-pad'>
        <Link to={buildPath(publicRoutePaths.COMPANY_CATALOGUE, {
          id: data.id
        })} href={buildPath(publicRoutePaths.COMPANY_CATALOGUE, {
          slug: data.id
        })} target="_blank">
          {
            data && <div className='img-wrape mp-supplier-img-wrape'>
              <img src={data.company_logo ? IMAGE_PATH.BASE_URL + data.company_logo : companylogo} alt='' />
            </div>
          }

          <h3 title={data && data.company_name}>{data && data.company_name}</h3>
          {
            data && <span className='price-qty mp-supplier-price-qty'> {data.member_industry && data.member_industry.industy_name}</span>
          }

          <div className='flag-section'>
            {/* <i className='flag'></i> */}
            {data && data.country && <img src={require(`@/assets/images/svg/flag/${lowerCase(data.country?.iso3)}.svg`)} alt="" style={{ height: 24, width: 24 }} />}
            {
              data && <span title={data && data.shipment_mode}>{data.shipment_mode}</span>
            }
          </div>

        </Link>

        {
          showContact && <div className="btn-wrape">
            {/* <Link
              className="btn outline"
              to="/"
              title="Contact Suppliers"
            > */}
            <button type="button"
              className="btn outline medium"
              onClick={() => handleQuoteClick(data)}
            >
              Contact Supplier
              <span className="round">
                <i className="sprite"></i>
              </span>
            </button>
            {/* </Link> */}
          </div>
        }

      </div>
    </div>
  )
}

export default MpSupplierCard;